<template>
  <k-dialog @close="cancel" :max-width="400" :title="action">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Claim Type</label>

          <div class="col-sm-9">
            <k-input
              v-if="this.action == 'Add Role Claim'"
              type="text"
              :name="'userName'"
              v-model="roleClaimInEdit.claimType"
              class="form-control"
              required
            ></k-input>
            <p class="form-control" v-else>
              {{ roleClaimInEdit.claimType }}
            </p>
          </div>
        </div>

        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Claim Value :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'userName'"
              v-model="roleClaimInEdit.claimValue"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
      </div>
      <input type="submit" id="submit-form" class="d-none" />
    </form>
    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>

  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-multiselect": MultiSelect,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
  },
  data: function () {
    return {
      roleClaimInEdit: {
        claimType: "",
        claimValue: "",
      },
      action: "",
      multiselectValue: [],
    };
  },
  validations: {
    roleClaimInEdit: {},
  },
  created: function () {
    if (this.$props.dataItem) {
      this.roleClaimInEdit = this.$props.dataItem;
    }
    this.action = this.$props.dialogTitle;
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      console.log("SAVED");
      if (this.action == "Edit Role Claim") {
        this.$emit("save");
      } else {
        this.$emit("save");
      }
    },
  },
};
</script>
<style scoped>
</style>